// Personal settings: name, diets, allergies, diet plan, hands-free info.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from '../store/settings';
import { Body, Button, Caption, Chip, Field, ListItem, Row, Screen, Section, ToggleRow } from '../components/ui';
import { useNav } from '../navigation';
import { DIETS } from '../types';
import { ALLERGENS, dietPlan } from '../logic/dietPlan';
import { usePalette } from '../theme';

export default function PersonalSettingsScreen() {
  const { t } = useTranslation();
  const s = useSettings();
  const nav = useNav();
  const p = usePalette();
  const plan = s.dietProfile ? dietPlan(s.dietProfile) : null;
  return (
    <Screen>
      <Field label={t('settings.displayName')} value={s.displayName} onChangeText={v => s.set({ displayName: v })} />
      <Section title={t('settings.diets')} icon="diet">
        <Row>
          {DIETS.map(d => {
            const on = s.diets.includes(d);
            return <Chip key={d} label={t(`diets.${d}`)} selected={on} onPress={() => s.set({ diets: on ? s.diets.filter(x => x !== d) : [...s.diets, d] })} />;
          })}
        </Row>
        <Caption>{t('settings.dietsNote')}</Caption>
        <ListItem title={t('dietRules.title')} icon="help" onPress={() => nav.navigate('Info', { page: 'dietRules' })} />
        <ToggleRow label={t('settings.restrictDiet')} note={t('settings.restrictDietNote')} value={s.restrictDiet} onChange={v => s.set({ restrictDiet: v })} />
      </Section>
      <Section title={t('settings.allergies')} icon="warning">
        <Row>
          {ALLERGENS.map(a => {
            const on = s.allergies.includes(a);
            return <Chip key={a} label={t(`allergens.${a}`)} color={p.danger} selected={on} onPress={() => s.set({ allergies: on ? s.allergies.filter(x => x !== a) : [...s.allergies, a] })} />;
          })}
        </Row>
        <Caption>{t('settings.allergiesNote')}</Caption>
      </Section>
      <Section title={t('settings.nutrition')} icon="nutrition">
        <ToggleRow label={t('settings.showMicros')} value={s.showsMicronutrients} onChange={v => s.set({ showsMicronutrients: v })} />
        <ListItem
          title={t('dietPlan.title')}
          subtitle={plan ? t('dietPlan.perDay', { kcal: plan.calories }) : t('dietPlan.notSetUp')}
          icon="nutrition"
          onPress={() => nav.navigate('DietPlan')}
        />
        {s.dietProfile ? <Button label={t('dietPlan.delete')} icon="trash" variant="secondary" onPress={() => s.set({ dietProfile: null, dietPlanSkipped: true })} /> : null}
      </Section>
      <Section title={t('settings.handsFree')} icon="info">
        <Body secondary>{t('settings.handsFreeBody')}</Body>
      </Section>
    </Screen>
  );
}
